import { useLedgerStore } from '../hooks/use-ledger-store';
import { ViewType } from '../types';
import { 
  LayoutDashboard, 
  ReceiptText, 
  Handshake, 
  Users,
  Plus
} from 'lucide-react';
import { motion } from 'motion/react';

export default function MobileNav() {
  const { view, setView } = useLedgerStore();

  const navItems = [
    { id: 'dashboard', label: '首頁', icon: LayoutDashboard },
    { id: 'expenses', label: '紀錄', icon: ReceiptText },
    { id: 'add-expense', label: '新增', icon: Plus, isAction: true },
    { id: 'settlements', label: '結算', icon: Handshake },
    { id: 'members', label: '成員', icon: Users },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-xl border-t border-border px-4 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] flex items-center justify-around md:hidden">
      {navItems.map((item) => {
        const isActive = view === item.id;
        
        if (item.isAction) {
          return (
            <button
              key={item.id}
              onClick={() => setView('add-expense')}
              aria-label="新增支出"
              className="relative -top-5 bg-primary text-primary-foreground p-4 rounded-2xl shadow-wash hover:scale-105 active:scale-95 transition-all"
            >
              <item.icon size={24} strokeWidth={3} />
            </button>
          );
        }

        return (
          <button
            key={item.id}
            onClick={() => setView(item.id as ViewType)}
            className="flex flex-col items-center gap-1 group relative"
          >
             <div className={`p-2 rounded-xl transition-all ${isActive ? 'bg-primary/10 text-primary' : 'text-muted-foreground group-hover:bg-muted-foreground/10'}`}>
               <item.icon size={20} strokeWidth={isActive ? 2.5 : 2} />
             </div>
             <span className={`text-xs font-bold ${isActive ? 'text-primary' : 'text-muted-foreground'}`}>{item.label}</span>
             {isActive && (
               <motion.div 
                 layoutId="nav-indicator"
                 className="absolute -bottom-1 w-1 h-1 rounded-full bg-primary"
               />
             )}
          </button>
        );
      })}
    </nav>
  );
}
